import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Grid } from '@mui/material';

export default function ProductLineSkeleton() {
  return (
    <Grid container p={4} spacing={2}>
      <Grid item xs={6} my={1}>
        <Skeleton variant="rectangular" ></Skeleton>
      </Grid>
      <Grid item xs={6} my={1}>
        <Skeleton variant="rectangular" ></Skeleton>
      </Grid>
    </Grid>
  );
}